import { DashboardApiEndpoints } from '@contracts';

export const DASHBOARD_ENDPOINTS: DashboardApiEndpoints = {
  get: {
    dashboard_mdb: {
      path: 'get/dashboard_mdb/',
      domain: 'core',
      version: 'v1',
    },
    dashboard_mdb_data: {
      path: 'get/dashboard_mdb_data/',
      domain: 'core',
      version: 'v1',
    },
  },
};
